import { CommodityAssignee } from "@bechtel/types";
import { useAppUser } from "~/components";

export function useWeldOwner(assignedCrewMembers?: CommodityAssignee[], crewMemberId?: string): boolean {
  const { user } = useAppUser();
  const idToCheck = crewMemberId || (user && user.id);
  if (assignedCrewMembers && assignedCrewMembers.length && idToCheck)
    return assignedCrewMembers.some((assignedCrewMember) => assignedCrewMember?.assignee?.id === idToCheck);
  return false;
}
